<template>
  <div class="wt-zoom-page">
    <layout-general>
      <layout-header slot="header"></layout-header>
      <div class="wt2-sg -zoom-caption" slot="top">
        <span class="wt2-text-n">{{
          'overlayAssets.zoom.targetArea' | culture
        }}</span>
      </div>
      <zoom-left-bar slot="left"></zoom-left-bar>
      <main-stage slot="main">
        <zoom-stage :active="true" :primary="true"></zoom-stage>
      </main-stage>
      <zoom-apply-cancel slot="footer"></zoom-apply-cancel>
    </layout-general>
  </div>
</template>

<script>
import LayoutGeneral from 'AssetEditor/layouts/LayoutGeneral.vue';
import ZoomApplyCancel from 'AssetEditor/functionality/Zoom/ZoomApplyCancel.vue';
import LayoutHeader from 'AssetEditor/layouts/LayoutHeader.vue';
import ZoomLeftBar from 'AssetEditor/functionality/Zoom/ZoomLeftBar.vue';
import ZoomStage from 'AssetEditor/functionality/Zoom/ZoomStage.vue';
import MainStage from 'AssetEditor/functionality/Stage/MainStage.vue';

export default {
  components: {
    ZoomLeftBar,
    LayoutGeneral,
    LayoutHeader,
    ZoomApplyCancel,
    ZoomStage,
    MainStage,
  },
};
</script>

<style lang="scss" scoped>
.-zoom-caption {
  margin-bottom: 10px;
}
</style>
